// extracted by mini-css-extract-plugin
module.exports = {"bird":"_1_jtEY","button":"_32gAvz"};